import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DmToaster } from '@digitale-menschen/component-library-angular';
import { ConfirmDialogComponent, LanguageService } from '@lexplus-shared-lib';

@Component({
  imports: [RouterOutlet, DmToaster, ConfirmDialogComponent],
  selector: 'lp-root',
  templateUrl: './app.html',
})
export class App implements OnInit {
  private readonly languageService = inject(LanguageService);

  public ngOnInit(): void {
    this.languageService.initLanguageAndListeners();
  }
}
